import React from "react";
import { Row, Col } from "antd";
import { Modal } from "../../../core";
import { Input, Typography, Button, Loading } from "../../../core";
import styled from "styled-components";
import { Form } from "antd";
import { MixStyle } from "../../../styles";
import { updateYarnQuality } from "../../../helper/utils/api/settings";
const Notify_Utils = require("../../../helper/utils/Notification");

const layout = {
  labelCol: {
    span: 24,
  },
  wrapperCol: {
    span: 24,
  },
};

const StyledForm = styled(Form)`
  label {
    ${MixStyle.Label};
  }
`;

const AddYarnQuality = ({
  editYarnQualityModal,
  closeModal,
  getYarnQualities,
  dataToEdit,
}) => {
  const [form] = Form.useForm();

  const [updatedValue, setUpdatedValue] = React.useState({});
  const [formInitialValue, setFormInitialValue] = React.useState({});
  const [isLoading, setIsLoading] = React.useState(false);

  React.useEffect(() => {
    console.log("useeFFECT RUNINS");
    setFormInitialValue(dataToEdit);
  }, [dataToEdit]);

  const onFinish = async (fieldsValue) => {
    setIsLoading(true);
    await updateCompanyHandler();
    setIsLoading(false);
  };

  const updateCompanyHandler = async () => {
    try {
      let yarnQualityIdToEdit = formInitialValue._id;
      let response = await updateYarnQuality(yarnQualityIdToEdit, updatedValue);
      Notify_Utils.openNotificationWithIcon("success", response.data.message);
      closeModalHandler();
      getYarnQualities();
    } catch (error) {
      Notify_Utils.openNotificationWithIcon(
        "error",
        "Error While update yarn quality"
      );
      console.log("error while update", error);
    }
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const onValuesChange = (changedValues, valuse) => {
    console.log(changedValues);
    setUpdatedValue((prev) => ({ ...prev, ...changedValues }));
  };

  const closeModalHandler = () => {
    closeModal("editYarnQualityModal");
  };

  return (
    <Modal
      closable={true}
      visible={editYarnQualityModal}
      okText="Add"
      maxwidth="568px"
      footer={false}
      onCancel={closeModalHandler}
      tittle="Edit Yarn Quality"
    >
      {/* <EditYarnQualityForm
        getYarnQualities={getYarnQualities}
        closeModal={closeModal}
      /> */}
      {isLoading ? <Loading /> : null}
      <StyledForm
        autocomplete="off"
        form={form}
        {...layout}
        name="basic"
        initialValues={formInitialValue}
        onValuesChange={onValuesChange}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
      >
        <Row
          gutter={{ xs: 0, sm: 48, md: 48, lg: 48 }}
          type="flex"
          justify="center"
        >
          <Col md={12} sm={18} xs={24}>
            <Form.Item
              label="Count"
              name="count"
              rules={[
                {
                  required: true,
                  message: "Please input count!",
                },
              ]}
            >
              <Input type="number" placeholder="Count" />
            </Form.Item>
          </Col>
          <Col md={12} sm={18} xs={24}>
            <Form.Item
              label="Type"
              name="type"
              rules={[
                {
                  required: true,
                  message: "Please input type!",
                },
              ]}
            >
              <Input placeholder="Type" />
            </Form.Item>
          </Col>
          <Col md={12} sm={18} xs={24}>
            <Form.Item
              label="Brand"
              name="brand"
              rules={[
                {
                  required: true,
                  message: "Please input Brand!",
                },
              ]}
            >
              <Input placeholder="Brand" />
            </Form.Item>
          </Col>
          <Col md={12} sm={18} xs={24}>
            <Form.Item
              label="Cone Size"
              name="consize"
              rules={[
                {
                  required: true,
                  message: "Please input conesize!",
                },
              ]}
            >
              <Input type="number" placeholder="Cone Size" />
            </Form.Item>
          </Col>
          <Col md={13} sm={18} xs={24}>
            <Row type="flex" justify="space-between">
              <Col sm={10}>
                <Button bg="#404E67" type="primary" htmlType="submit">
                  <Typography
                    text="Update"
                    as="h5"
                    noMargin
                    weight="bold"
                    align="center"
                    color="white"
                  />
                </Button>
              </Col>
              <Col sm={10}>
                <Button bg="#404E67" type="primary" onClick={closeModalHandler}>
                  <Typography
                    text="Cancel"
                    as="h5"
                    noMargin
                    weight="bold"
                    align="center"
                    color="white"
                  />
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
      </StyledForm>
    </Modal>
  );
};

export default AddYarnQuality;
